import { updateObject } from '../../helpers/utility.helper';
import { initialState } from '../state/sensorData.state';
import ISensorDataState from '../models/ISensorDataState';
import iaqSensorDataType from '../types/iaqSensorData.type';

const getIAQSensorDataStart = (oldState: ISensorDataState, action: any) => {
    return updateObject(oldState, {
        sensorDataList: updateObject(oldState.sensorDataList, {
            error: null, loading: true, success: false,
        })
    });
};

const getIAQSensorDataSuccess = (oldState: ISensorDataState, action: any) => {
    return updateObject(oldState, {
        sensorDataList: updateObject(oldState.sensorDataList, {
            datas: action.payload,
            error: null,
            success: true,
            loading: false
        })
    });
};

const getIAQSensorDataError = (oldState: ISensorDataState, action: any) => {
    return updateObject(oldState, {
        sensorDataList: updateObject(oldState.sensorDataList, {
            error: action.payload,
            success: false,
            loading: false
        })
    });
};

const resetIAQSensorDataError = (oldState: ISensorDataState, action: any) => {
    return updateObject(oldState, {
        sensorDataList: updateObject(oldState.sensorDataList, {
            error: null,
            success: false,
            loading: false
        })
    });
};

const iaqSensorDataReducer = (oldState: ISensorDataState = initialState, action: any) => {
    switch (action.type) {
        case iaqSensorDataType.GET_IAQ_SENSOR_DATA_START: return getIAQSensorDataStart(oldState, action);
        case iaqSensorDataType.GET_IAQ_SENSOR_DATA_SUCCESS: return getIAQSensorDataSuccess(oldState, action);
        case iaqSensorDataType.GET_IAQ_SENSOR_DATA_ERROR: return getIAQSensorDataError(oldState, action);
        case iaqSensorDataType.RESET_IAQ_SENSOR_DATA: return resetIAQSensorDataError(oldState, action);
        default: return oldState;
    }
};
export default iaqSensorDataReducer;